// extracted by mini-css-extract-plugin
module.exports = {"modalFooter":"styles_modalFooter__1r0jX","footerButton":"styles_footerButton__8fwWO","modalBody":"styles_modalBody__6jkTU","modalHeader":"styles_modalHeader__fSvK4"};